import styled from 'styled-components';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import { kassimBlue } from '../../style/theme';

const MainContainer = styled.div`
    margin-bottom: 16px;
    padding: 8px 32px;
    /* background: ${kassimBlue}; */
    color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
`;

const MainContentContainer = styled.div``;

const ActionContainer = styled(ButtonGroup)`
    margin-left: 48px;
    min-width: 160px;
    text-align: right;
    align-self: flex-start;

    & .MuiButtonGroup-groupedTextHorizontal:not(:last-child) {
        border-color: rgba(255, 255, 255, 0.23);
    }
`;

const Title = styled.div`
    font-size: 140%;
    font-weight: bold;
    line-height: 1.5;
    padding: 4px 0px;
    flex: 1;
`;
const InfoBlock = styled.div`
    font-size: 85%;
    color: #ccc;
    /* border: 1px solid #ccc;
    border-radius: 8px; */
    font-style: italic;
    padding: 4px 8px;
    margin: 4px 0px;
`;

const StyledButton = styled(Button)`
    color: #fff;
    white-space: nowrap;
`;

const GameHeader = ({ title, info, actions = [] }) => {
    return (
        <MainContainer>
            <MainContentContainer>
                <Title>{title}</Title>
                {info && <InfoBlock>{info}</InfoBlock>}
            </MainContentContainer>
            <ActionContainer variant="text">
                {actions.map(({ onClick, label, key }) => (
                    <StyledButton key={key} onClick={onClick}>
                        {label}
                    </StyledButton>
                ))}
            </ActionContainer>
        </MainContainer>
    );
};

export default GameHeader;
